
import React, { createContext, useContext, useState } from 'react';
import { useToast } from './ToastProvider';
import { Result } from '@peercolab/engine';
import { Session } from '../peer-colab-model/Session';
import { CourseCategoryManagement } from '../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import { CourseCategory } from '../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Categories/PathItems';

type CourseCategoryContextType = {
  courseCategories: CourseCategory[];
  loadCourseCategories: () => Promise<Result<CourseCategory[]>>
};

const CourseCategoryContext = createContext<CourseCategoryContextType | undefined>(undefined);

export const CourseCategoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { onError } = useToast();
  const [courseCategories, setCourseCategories] = useState<CourseCategory[]>([]);

  const loadCourseCategories = async (): Promise<Result<CourseCategory[]>> => {
    return onError((await Session.getClient().request(CourseCategoryManagement.getAllCourseCategorys()))
      .maybePassThroughOk((match) => {
        setCourseCategories([...match]);
      }));
  }

  return (
    <CourseCategoryContext.Provider value={{ courseCategories, loadCourseCategories }}>
      {children}
    </CourseCategoryContext.Provider>
  );
};

export function useCourseCategories() {
  const ctx = useContext(CourseCategoryContext);
  if (!ctx) throw new Error('useCourseCategories must be used within a CourseCategoryProvider');
  return ctx;
}
